export default {
  isOffline: (state) => state.isOffline,
  isMenuOpen: (state) => state.isMenuOpen,
  isLoading: (state) => state.isLoading,
  isUpdateAvailable: (state) => state.updateAvailable,
  screenSize: (state) => state.screenSize,
}
